import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingOutlined } from "@ant-design/icons";
import { Image, Spin } from "antd";
import classNames from "classnames";
import { useHistory } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import {
    FacebookIcon,
    InstagramIcon,
    LinkedinIcon,
    MediumIcon,
    PinterestIcon,
    XIcon
} from "svgIcon";
import { getMerchantSetting, getMerchantProduct } from "apiServices/app";
import HomeImage from "assets/images/homejpg.jpg";
import bannerBg from "assets/images/bannerBg.png";
import suifrensFooter from "assets/images/suifrens/suifrensBanner.svg";
import BackgroundVideo from '../../ECBasic/ECHeroSectionComponent/BackgroundVideo';
import { CryptoPassword, encryptedText } from "utils/crypto";
import {
    SuiFrensFlow,
    getSecondSegment,
    toastMessage,
    useGlobalMerchant
} from 'utils/helper';
import { baseImageURL, siteRecaptchaKey } from "utils/env";
import ECSCRouteComponent from '../ECSCRouteComponent';
import ECSHeaderComponent from '../ECSHeaderComponent';
import ECAddressWrapperComponent from '../../ECAddressWrapperComponent';
import { useStyles } from './style';

const ECSuiFrensComponent = () => {
    const { isEndsWithSlash, ecommerceContent, globalMerchantId } = useGlobalMerchant();
    const [merchantContent, setMerchantContent] = useState<any>({});

    const [showShippingLayout, setShowShippingLayout] = useState(false);
    const [showSideBasket, setShowSideBasket] = useState(false);
    const { setProductContent } = useGlobalMerchant();
    const classes = useStyles();
    const history = useHistory();

    function getFileType(filePath: string): "image" | "video" {
        const isVideo = filePath.toLowerCase().endsWith(".mp4");
        return isVideo ? "video" : "image";
    }

    const manageBgDetails = (getPath: any) => {
        if (getPath == null) {
            return <Image src={HomeImage} alt="background image" preview={false} />;
        } else {
            const fileType = getFileType(getPath);
            if (fileType === "image") {
                return <Image src={`${baseImageURL}${getPath}`} alt="background image" preview={false} />;
            } else {
                const videoSource = `${baseImageURL}${getPath}`;
                return <BackgroundVideo videoSource={videoSource}></BackgroundVideo>;
            }
        }
    };

    const renderLogoIcon = () => {
        return (
            <Image
                src={merchantContent.logo_path !== null ? `${baseImageURL}${merchantContent.logo_path}` : bannerBg}
                alt="profile Picture"
                preview={false}
            />
        )
    }

    const onGetMerchantDetails = (getUserKey: any) => {
        try {
            getMerchantSetting(getUserKey)
                .then((response) => {
                    const responseData = response.data || response;
                    if (responseData !== null && responseData.success !== false) {
                        if (responseData && responseData.success == false) {
                            toastMessage("You dont have any profile");
                        } else {
                            setMerchantContent(responseData);
                            localStorage.setItem("ec-email", encryptedText(CryptoPassword, responseData.merchant_email));
                        }
                    }
                })
                .catch((error) => { console.log(error); });
        } catch (error: any) { }
    };

    const getMerchantProducts = (getMerchantId: any) => {
        try {
            getMerchantProduct(getMerchantId)
                .then((response) => {
                    const responseData = response.data || response;
                    if (responseData !== null && responseData.success !== false) {
                        if (responseData.length === 0) {
                            toastMessage("OOPS you dont have any product");
                        } else {
                            const getSecondValue = getSecondSegment(window.location.pathname);
                            const product = responseData.find((item: any) => item.product_name.toLowerCase() === getSecondValue.toLowerCase());
                            if (!!product) { setProductContent(product); }
                        }
                    }
                })
                .catch((error) => { toastMessage(error); });
        } catch (error: any) { }
    };

    useEffect(() => {
        try {
            if (isEndsWithSlash && history && history.action && history.action === "POP") {
                getMerchantProducts(globalMerchantId);
                onGetMerchantDetails(globalMerchantId);
            } else {
                onGetMerchantDetails(globalMerchantId);
            }
        } catch (error) { console.log("Something went wrong"); }
    }, []);

    return (
        <>
            {Object.keys(merchantContent).length == 0 ? (
                <div className="loaderCenterWrapper">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            ) : (
                <div className={classNames(classes.ecSuiFrensWrapper)}>
                    <ToastContainer />
                    <div className='topWrapper textCenter'>
                        <p className="sNmText textUpper fontSemiBold">{ecommerceContent.head_title}</p>
                    </div>
                    <div className="mainWrapper">
                        <GoogleReCaptchaProvider reCaptchaKey={siteRecaptchaKey}>
                            <ECSHeaderComponent
                                renderLogoIcon={renderLogoIcon}
                                showShippingLayout={showShippingLayout}
                                setShowSideBasket={setShowSideBasket}
                                showSideBasket={showSideBasket}
                                setShowShippingLayout={setShowShippingLayout}
                                ecommerceContent={ecommerceContent}
                            />
                        </GoogleReCaptchaProvider>
                        <div className="container">
                            {showShippingLayout ? (
                                <ECAddressWrapperComponent flowName={SuiFrensFlow} setShowShippingLayout={setShowShippingLayout} />
                            ) : (
                                <>
                                    {!isEndsWithSlash && (
                                        <div className="bannerSection textCenter">
                                            <div className="bBg">
                                                {manageBgDetails(ecommerceContent.ecom_video_link)}
                                            </div>
                                        </div>
                                    )}
                                    <ECSCRouteComponent />
                                </>
                            )}
                        </div>
                        <div className="exfooterWrapper dFlex flexCol justifyCenter alignCenter">
                            <div className="container">
                                <div className="footerLogo dFlex justifyCenter alignCenter">
                                    {/* <div>{renderLogoIcon()}</div> */}
                                    <img src={suifrensFooter} alt="suifrensFooter" />
                                </div>
                                {/* <p className="textCenter">{ecommerceContent.foot_title}</p> */}
                                <p className="mt20 textCenter fontBold sNmText">{ecommerceContent.foot_title}</p>
                                <div className="socialIcons dFlex alignCenter justifyCenter gap20 mt50">
                                    <span className="cursorPointer"><XIcon /></span>
                                    <span className="cursorPointer"><LinkedinIcon /></span>
                                    <span className="cursorPointer"><FacebookIcon /></span>
                                    <span className="cursorPointer"><PinterestIcon /></span>
                                    <span className="cursorPointer"><MediumIcon /></span>
                                    <span className="cursorPointer"><InstagramIcon /></span>
                                </div>
                            </div>
                            <div className="quickLinks dFlex alignCenter justifyCenter gap30">
                                <li><a href="" className="sXSmText fontMedium">FAQ</a></li>
                                <li><a href="" className="sXSmText fontMedium">Refund policy</a></li>
                                <li><a href="" className="sXSmText fontMedium">Private policy</a></li>
                                <li><a href="" className="sXSmText fontMedium">Terms of service</a></li>
                                <li><a href="" className="sXSmText fontMedium">Contact information</a></li>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ECSuiFrensComponent